import React, { FC } from 'react';
import { useItem } from '@api/generics';
import QueryKeys from '@api/index';
import API_ROUTES from '@api/routes';
import Loader from '@components/Loader/Loader';
import { IWizard } from 'types/wizard';
import Wizard from './Wizard/Wizard';

const GettingStartedPage: FC = () => {
	const { data, isLoading } = useItem<IWizard>(
		QueryKeys.wizard,
		API_ROUTES.v1.wizard.update
	);

	return (
		<Loader isLoading={isLoading} variant="settings">
			{data && <Wizard state={data} />}
		</Loader>
	);
};

export default GettingStartedPage;
